enum CalendarEvents {
  CalendarEpisodePageLinkOpen = 'CalendarEpisodePageLinkOpen',
  CalendarEpisodePagePreviewOpen = 'CalendarEpisodePagePreviewOpen'
};

export default CalendarEvents;
